import productImg1 from '../assets/images/placeholder-images/placeholder-image (1).png';
import productImg2 from '../assets/images/placeholder-images/placeholder-image (2).png';
import productImg3 from '../assets/images/placeholder-images/placeholder-image (3).png';
import productImg4 from '../assets/images/placeholder-images/placeholder-image (4).png';
import productImg5 from '../assets/images/placeholder-images/placeholder-image (5).png';
import productImg6 from '../assets/images/placeholder-images/placeholder-image (6).png';

/**
 * Demo products shown on the home page when the store
 * has not added any products yet.
 */
export const productPlaceholder = [
    {
        _id: 'placeholder-product-1',
        name: {
            en: 'Modern Streetwear Hoodie',
            tr: 'Modern Sokak Giyimi Hoodie',
            fa: 'هودی خیابانی مدرن',
            ar: 'هودي عصري',
            el: 'Μοντέρνο Streetwear Hoodie',
            ru: 'Современное худи в уличном стиле',
        },
        description: {
            en: 'Comfortable and stylish hoodie made from premium cotton blend.',
            tr: 'Birinci sınıf pamuk karışımından üretilmiş rahat ve şık hoodie.',
            fa: 'هودی راحت و شیک ساخته شده از ترکیب پنبه ممتاز.',
            ar: 'هودي مريح وأنيق مصنوع من مزيج القطن الفاخر.',
            el: 'Άνετο και κομψό hoodie από premium μείγμα βαμβακιού.',
            ru: 'Комфортное и стильное худи из высококачественного хлопка.',
        },
        price: 45,
        imageUrl: [productImg1],
        rating: 4.8,
        brand: 'Urban Core',
        isNewItem: true,
        isFeatured: true,
        status: 'active',
        availability: true,
    },
    {
        _id: 'placeholder-product-2',
        name: {
            en: 'Elegant Summer Dress',
            tr: 'Zarif Yazlık Elbise',
            fa: 'لباس تابستانی شیک',
            ar: 'فستان صيفي أنيق',
            el: 'Κομψό Καλοκαιρινό Φόρεμα',
            ru: 'Элегантное летнее платье',
        },
        description: {
            en: 'Light and breathable dress perfect for warm summer days.',
            tr: 'Sıcak yaz günleri için mükemmel, hafif ve nefes alabilen elbise.',
            fa: 'لباس سبک و خنک، ایده‌آل برای روزهای گرم تابستان.',
            ar: 'فستان خفيف وجيد التهوية مثالي لأيام الصيف الدافئة.',
            el: 'Ελαφρύ και δροσερό φόρεμα, ιδανικό για τις ζεστές καλοκαιρινές μέρες.',
            ru: 'Легкое и дышащее платье, идеально подходящее для жарких летних дней.',
        },
        price: 55,
        imageUrl: [productImg2],
        rating: 4.9,
        brand: 'Luxe Bloom',
        isNewItem: false,
        isFeatured: true,
        status: 'active',
        availability: true,
    },
    {
        _id: 'placeholder-product-3',
        name: {
            en: 'Designer Leather Handbag',
            tr: 'Tasarım Deri El Çantası',
            fa: 'کیف دستی چرمی طراح',
            ar: 'حقيبة يد جلدية مصممة',
            el: 'Δερμάτινη Τσάντα Σχεδιαστή',
            ru: 'Дизайнерская кожаная сумка',
        },
        description: {
            en: 'Crafted from genuine leather, this handbag adds a touch of sophistication.',
            tr: 'Hakiki deriden üretilen bu el çantası, sofistike bir dokunuş katar.',
            fa: 'ساخته شده از چرم طبیعی، این کیف دستی حسی از پیچیدگی را اضافه می‌کند.',
            ar: 'حقيبة يد مصنوعة من الجلد الطبيعي، تضفي لمسة من الرقي.',
            el: 'Κατασκευασμένη από γνήσιο δέρμα, αυτή η τσάντα προσθέτει μια νότα κομψότητας.',
            ru: 'Эта сумка, выполненная из натуральной кожи, добавит образу изысканности.',
        },
        price: 120,
        imageUrl: [productImg3],
        rating: 4.7,
        brand: 'Vogue Craft',
        isNewItem: true,
        isFeatured: true,
        status: 'active',
        availability: true,
    },
    {
        _id: 'placeholder-product-4',
        name: {
            en: 'Classic Cotton T-Shirt',
            tr: 'Klasik Pamuklu Tişört',
            fa: 'تی‌شرت پنبه‌ای کلاسیک',
            ar: 'تي شيرت قطني كلاسيكي',
            el: 'Κλασικό Βαμβακερό T-Shirt',
            ru: 'Классическая хлопковая футболка',
        },
        description: {
            en: 'A versatile and comfortable t-shirt made from 100% organic cotton.',
            tr: '%100 organik pamuktan üretilmiş çok yönlü ve rahat bir tişört.',
            fa: 'یک تی‌شرت همه‌کاره و راحت ساخته‌شده از ۱۰۰٪ پنبه ارگانیک.',
            ar: 'تي شيرت مريح ومتعدد الاستخدامات مصنوع من القطن العضوي 100٪.',
            el: 'Ένα ευέλικτο και άνετο t-shirt από 100% οργανικό βαμβάκι.',
            ru: 'Универсальная и удобная футболка из 100% органического хлопка.',
        },
        price: 25,
        imageUrl: [productImg4],
        rating: 4.5,
        brand: 'Essential Wear',
        isNewItem: true,
        isFeatured: true,
        status: 'active',
        availability: true,
    },
    {
        _id: 'placeholder-product-5',
        name: {
            en: 'Premium Denim Jeans',
            tr: 'Premium Denim Kot Pantolon',
            fa: 'شلوار جین دنیم ممتاز',
            ar: 'بنطلون جينز دنيم متميز',
            el: 'Premium Denim Jeans',
            ru: 'Джинсы премиум-класса',
        },
        description: {
            en: 'High-quality denim jeans with a modern fit and durable construction.',
            tr: 'Modern kesimli ve dayanıklı yapısıyla yüksek kaliteli denim kot pantolon.',
            fa: 'شلوار جین دنیم با کیفیت بالا با تناسب مدرن و ساختار بادوام.',
            ar: 'بنطلون جينز دنيم عالي الجودة بمقاس حديث وهيكل متين.',
            el: 'Denim τζιν υψηλής ποιότητας με μοντέρνα εφαρμογή και ανθεκτική κατασκευή.',
            ru: 'Высококачественные джинсы современного кроя и прочной конструкции.',
        },
        price: 65,
        imageUrl: [productImg5],
        rating: 4.8,
        brand: 'Denim Co',
        isNewItem: false,
        isFeatured: true,
        status: 'active',
        availability: true,
    },
    {
        _id: 'placeholder-product-6',
        name: {
            en: 'Lightweight Summer Jacket',
            tr: 'Hafif Yazlık Ceket',
            fa: 'ژاکت تابستانی سبک',
            ar: 'جاكيت صيفي خفيف الوزن',
            el: 'Ελαφρύ Καλοκαιρινό Μπουφάν',
            ru: 'Легкая летняя куртка',
        },
        description: {
            en: 'Perfect for cool evenings, this jacket combines style with functionality.',
            tr: 'Serin akşamlar için mükemmel olan bu ceket, stili işlevsellikle birleştirir.',
            fa: 'ایده‌آل برای عصرهای خنک، این ژاکت استایل را با عملکرد ترکیب می‌کند.',
            ar: 'مثالي للأمسيات الباردة، يجمع هذا الجاكيت بين الأناقة والعملية.',
            el: 'Ιδανικό για δροσερά βράδια, αυτό το μπουφάν συνδυάζει στυλ και λειτουργικότητα.',
            ru: 'Эта куртка идеально подходит для прохладных вечеров, сочетая в себе стиль и функциональность.',
        },
        price: 45,
        imageUrl: [productImg6],
        rating: 4.2,
        brand: 'Urban Style',
        isNewItem: true,
        isFeatured: true,
        status: 'active',
        availability: true,
    },
];
